<template>
    <div class="">
        <div class="home_tab_layout">
            <div v-for="(item, index) in tabList" class="home_tab" :key="index" @click="checkTab(index)">
                <div :class="tabIndex == index ? 'home_tab_red_layout' : 'home_tab_txt_layout'">
                    {{ item.title }}
                </div>

            </div>
        </div>
        <!-- <div class="home_inc_check" :style="{ transform: `translateX(${tabIndex * 100}%)` }">
            <div class="home_tab_check"></div>
        </div> -->

    </div>
</template>

<script>
import Toast from "../../components/message.js";
import { AccountStore } from "../../util/Account.js";
export default {
    name: 'tabView',
    props: {
        title: String,
        msg: String,
    },
    emits: ["tab"],
    data() {
        return {
            tabList: [
                { title: "Task" },
                { title: "Ranking" },
            ],
            tabIndex: 0,
        }
    },

    watch: {

    },

    methods: {
        checkTab(index) {
            if (AccountStore.isUserLoginStatus == false) {
                return;
            }

            this.tabIndex = index;
            this.$emit("tab", index);
            // Toast("提交成功", "success");
        }



    },

    mounted() {

    },


}

</script>

<style scoped>
.home_tab_layout {
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    padding: 2px 2px;
    /* width: 120px; */
    width: -webkit-fill-available;
    width: -moz-available;
    background-color: #F9E6A8;
}

.home_tab_red_layout {
    border-radius: 8px;
    border: 1px #000;
    color: #000;
    text-align: center;
    -webkit-text-stroke-width: 1;
    -webkit-text-stroke-color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    /* 142.857% */
    letter-spacing: 0.14px;
    text-align: center;
    justify-content: center;
    background-color: #fff;
    padding: 6px;
    padding-left: 20px;
    padding-right: 20px;
}

.home_tab_txt_layout {
    color: #666;
    text-align: center;
    -webkit-text-stroke-width: 1;
    -webkit-text-stroke-color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    /* 142.857% */
    letter-spacing: 0.14px;
    background: transparent;
    padding: 6px;
    padding-left: 20px;
    padding-right: 20px;
}

.home_inc_check {
    transition: transform 0.5s ease;
    margin-top: 2px;
    width: 60px;
}

.home_tab_check {
    width: 48px;
    height: 2px;
    flex-shrink: 0;
    background-color: #8F380E;

}

.home_tab_uncheck {
    width: 48px;
    height: 2px;
    flex-shrink: 0;
    background-color: transparent;
    transition: transform 0.5s ease;
}

.home_tab {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    cursor: pointer;
}
</style>